import type { DemoScript } from "../types";
import { WHATSAPP_SCRIPT_COPY } from "./whatsapp-script.copy";

/**
 * Roteiro da demo de WhatsApp — mostra a Tãmi vivendo no WhatsApp do creator:
 *  1. Agenda do dia (proativa, disparada por cron — espelha buildDailyAgendaMessage)
 *  2. Agendamento de conteúdo por mensagem (a Tãmi cria o planejamento)
 *  3. Agendamento de evento no calendário por mensagem
 *  4. Resumo de performance semanal (proativo, cron — espelha buildWeeklyEngagementMessage)
 *
 * A ordem dos passos define o índice usado pelo whatsapp-demo para revelar as mensagens.
 */
export const buildWhatsappScript = (): DemoScript => [
  {
    id: "whatsapp-intro",
    narrative: WHATSAPP_SCRIPT_COPY.whatsappIntro.narrative,
    durationMs: 3200,
  },
  {
    id: "whatsapp-agenda",
    narrative: WHATSAPP_SCRIPT_COPY.whatsappAgenda.narrative,
    zoomTargetId: "wpp-agenda",
    disableZoom: true,
    callout: {
      targetId: "wpp-agenda",
      text: WHATSAPP_SCRIPT_COPY.whatsappAgenda.callout,
    },
    durationMs: 5600,
  },
  {
    id: "whatsapp-content",
    narrative: WHATSAPP_SCRIPT_COPY.whatsappContent.narrative,
    zoomTargetId: "wpp-content",
    disableZoom: true,
    callout: {
      targetId: "wpp-content",
      text: WHATSAPP_SCRIPT_COPY.whatsappContent.callout,
    },
    durationMs: 5600,
  },
  {
    id: "whatsapp-event",
    narrative: WHATSAPP_SCRIPT_COPY.whatsappEvent.narrative,
    zoomTargetId: "wpp-event",
    disableZoom: true,
    callout: {
      targetId: "wpp-event",
      text: WHATSAPP_SCRIPT_COPY.whatsappEvent.callout,
    },
    durationMs: 5400,
  },
  {
    id: "whatsapp-performance",
    narrative: WHATSAPP_SCRIPT_COPY.whatsappPerformance.narrative,
    zoomTargetId: "wpp-performance",
    disableZoom: true,
    callout: {
      targetId: "wpp-performance",
      text: WHATSAPP_SCRIPT_COPY.whatsappPerformance.callout,
    },
    durationMs: 5800,
  },
  {
    id: "whatsapp-outro",
    narrative: WHATSAPP_SCRIPT_COPY.whatsappOutro.narrative,
    durationMs: 3200,
  },
];

/** Ordem dos passos — usada pelo whatsapp-demo para calcular quando revelar cada bloco. */
export const WHATSAPP_STEP_IDS = buildWhatsappScript().map((step) => step.id);
